import { Thumb } from './Thumb';
import { Submenu } from './Submenu';
import { Checkbox } from './Checkbox';
import { WarningIcon } from './WarningIcon';

export default { Thumb, Submenu, Checkbox, WarningIcon };
